export function Footer() {
  return (
    <div className="text-center mt-8">
      <div className="flex justify-center items-center space-x-2 text-base text-white/60">
        <a href="/masterplan" className="hover:text-white/80 transition-colors duration-300">
          Manifesto
        </a>
        <span>|</span>
        <a href="/" className="hover:text-white/80 transition-colors duration-300">The Sentience Company 2025</a>
        <span>|</span>
        <a href="https://discord.gg/6ZmkEUYYAA" className="hover:text-white/80 transition-colors duration-300">Community</a>
      </div>
      
      <div className="flex justify-center items-center space-x-2 text-xs text-white/40 mt-4">
        <a href="/privacy" className="hover:text-white/60 transition-colors duration-300">
          Privacy
        </a>
        <span>|</span>
        <a href="/terms" className="hover:text-white/60 transition-colors duration-300">
          Terms
        </a>
      </div>
    </div>
  );
} 